import { DSMD } from "./DSMD";
// Assuming there's a loader or context for custom fields
const customFields = {
 DSMD,
};
export default customFields;

